import React from 'react';
import './SocialMediaButtons.css';
import PropTypes from 'prop-types';
import socialsData from './socialsData.json';

const SocialMediaButtons = (props) => {
  const { icons } = socialsData;
  const { fromSidebar } = props;

  return (
    <div className={fromSidebar ? 'sidebar__socials' : null}>
      {icons.map((icon) => (
        <button
          key={Math.random()}
          type="button"
          className="icon__button"
          aria-label={`social-media-${icon.name}`}
          onClick={() => window.open(icon.url)}
        >
          <i className={`social__icon ${icon.name}`} />
        </button>
      ))}
    </div>
  );
};

SocialMediaButtons.propTypes = {
  fromSidebar: PropTypes.bool,
};

SocialMediaButtons.defaultProps = {
  fromSidebar: false,
};

export default SocialMediaButtons;
